/* eslint-disable prefer-const */
import { URL } from 'url';
// tslint:disable: no-class
// tslint:disable: parameter-properties
export class Success {
    constructor() {
        this.success = true;
    }
}
/**
 * Success object
 */
export function success() {
    return new Success();
}
/**
 * Converts object to const type.
 * If you using >3.4.5 typescript please do not use this function
 */
export function typedByValue(x) {
    return x;
}
/**
 * Provides default value. If given value is undefined or null
 * @param value - default value
 */
export function defaultValue(value) {
    return (data) => {
        if (data === null || data === undefined) {
            return value;
        }
        return data;
    };
}
/**
 * Return tuple [A,B]
 */
export function toTuple(a, b) {
    return [a, b];
}
/**
 * Make uuidv4 type string
 */
export function uuidv4() {
    // https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        // tslint:disable
        let r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
    // tslint:enable
}
export function hashCode(s) {
    // tslint:disable
    return (s || '').split('').reduce(function (a, b) {
        a = (a << 5) - a + b.charCodeAt(0);
        return a & a;
    }, 0);
}
export var Time;
(function (Time) {
    Time[Time["Second"] = 1000] = "Second";
    Time[Time["Minute"] = 60000] = "Minute";
    Time[Time["Hour"] = 3600000] = "Hour";
    Time[Time["Day"] = 86400000] = "Day";
})(Time || (Time = {}));
/**
 * Parses url to url object
 * @param url - Valid url
 * @public
 */
export function parseUrl(url) {
    return new URL(url);
}
/**
 * Converts url to relative url
 * @param url - Valid url
 * @public
 */
export function urlToRelative(url) {
    return url.replace(/^[^/]+\/\/[^/]+/, '');
}
